import { css } from '@emotion/react';
import { motion } from 'framer-motion';

import { useScreenViewerContext } from './ScreenViewerContext';

export const Timeline = () => {
  const { isAnimating, autoPlay, paginate, current } = useScreenViewerContext();

  const variants = {
    start: { x: '-100vw', transition: { duration: 0, ease: 'linear' } },
    end: {
      x: 0,
      transition: { duration: current?.duration || 15, ease: 'linear' },
    },
  };

  return (
    <motion.div
      initial="start"
      variants={variants}
      animate={isAnimating ? 'end' : 'start'}
      onAnimationComplete={(definition) => {
        if (definition === 'end' && autoPlay) {
          paginate(1);
        }
      }}
      css={(theme) => css`
        position: fixed;
        height: 0.5rem;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 15;
        background-color: ${theme.vars.palette.secondary.main};
        border-radius: 0 1rem 1rem 0;
      `}
    />
  );
};
